import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");
  const tries = useRef(0);

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setState("error"); return undefined; }
    let stop = false;
    const poll = async () => {
      if (stop || tries.current >= 12) { if (!stop) setState("error"); return; }
      tries.current += 1;
      try {
        const { data } = await api.get(`/billing/checkout/status/${sid}`);
        if (data.status === "complete") { setState("success"); return; }
        if (data.status === "expired") { setState("error"); return; }
      } catch { /* riprova */ }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { stop = true; };
  }, [params]);

  return (
    <div className="min-h-screen bg-page flex items-center justify-center px-4" data-testid="billing-success-page">
      <div className="w-full max-w-md bg-surface border border-border rounded-2xl p-8 text-center">
        {state === "checking" && (
          <>
            <Loader2 size={36} className="mx-auto animate-spin text-accent mb-4" />
            <h1 className="text-lg font-semibold text-text-primary">Confermiamo il pagamento…</h1>
            <p className="text-sm text-text-secondary mt-2">Pochi secondi, non chiudere la pagina.</p>
          </>
        )}
        {state === "success" && (
          <div data-testid="billing-success">
            <CheckCircle2 size={44} className="mx-auto text-success-strong mb-4" />
            <h1 className="text-lg font-semibold text-text-primary">Abbonamento attivo!</h1>
            <p className="text-sm text-text-secondary mt-2">
              Tutti i moduli del tuo piano sono attivi. La ricevuta arriva via email;
              fatture e carta si gestiscono da "Gestisci abbonamento".
            </p>
            <Link to="/dashboard" className="wl-btn wl-btn--primary mt-6 inline-flex" data-testid="billing-success-cta">
              Vai alla dashboard
            </Link>
          </div>
        )}
        {state === "error" && (
          <div data-testid="billing-error">
            <XCircle size={40} className="mx-auto mb-4" style={{ color: "var(--wl-danger-text, #b91c1c)" }} />
            <h1 className="text-lg font-semibold text-text-primary">Non riusciamo a confermare il pagamento</h1>
            <p className="text-sm text-text-secondary mt-2">
              Se hai completato il pagamento, l'attivazione arriverà comunque a breve.
              Altrimenti riprova dal catalogo servizi.
            </p>
            <Link to="/services" className="wl-btn wl-btn--primary mt-6 inline-flex">Torna al catalogo</Link>
          </div>
        )}
      </div>
    </div>
  );
}
